import React from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../api/queries/homeQueries";
import Tabs from "../../components/detail/Tabs";
import { FaqCard } from "../../components/FaqCard";
import { BotNav } from "../../components/layout/BotNav";
import { ProductBannerPassIntroduction } from "../../components/product-detail/ProductBannerPassIntroduction";
import { SwiperWithArrow } from "../../components/swiper/SwiperWithArrow";
import { UiTitle } from "../../components/text/UiTitle";
import { useResponsive } from "../../hooks/useResponsive";
import { usePfTranslate, useTranslationEx } from "../../hooks/useTranslationEx";
import Utils from "../../utils/utils";
import NetworkImage from "../../components/image/NetworkImage";
import { cdnImg, icAsset } from "../../components/image/image-src";
import CdnImage from "../../components/image/CdnImage";

const PassIntroduction: React.FC = () => {
  const { t2: t } = useTranslationEx();
  const { pfTl } = usePfTranslate();
  const { isDesktop, isTablet } = useResponsive();

  const tabs = [
    t("intro-Big Pass"),
    t("Growing Discount"),
    t("Big Pass Travel"),
    t("How to use"),
    t("Review"),
    t("FAQs"),
  ];
  const branches = [
    "branch-1.png",
    "branch-2.png",
    "branch-3.png",
    "branch-4.png",
    "branch-5.png",
    "branch-6.png",
    "branch-7.png",
    "branch-8.png",
    "branch-9.png",
    "branch-10.png",
    "branch-11.png",
    "branch-12.png",
    "branch-13.png",
    "branch-14.png",
    "branch-15.png",
    "branch-16.png",
    "branch-17.png",
    "branch-18.png",
    "branch-19.png",
    "branch-20.png",
    "branch-21.png",
    "branch-22.png",
    "branch-23.png",
    "branch-24.png",
    "branch-25.png",
    "branch-26.png",
    "branch-27.png",
    "branch-28.png",
    "branch-29.png",
    "branch-30.png",
    "branch-31.png",
    "branch-32.png",
    "branch-33.png",
    "branch-34.png",
    "branch-35.png",
    "branch-36.png",
    "branch-37.png",
    "branch-38.png",
    "branch-39.png",
    "branch-40.png",
    "branch-41.png",
    "branch-42.png",
    "branch-43.png",
    "branch-44.png",
    "branch-45.png",
    "branch-46.png",
    "branch-47.png",
    "branch-48.png",
    "branch-49.png",
    "branch-50.png",
    "branch-51.png",
    "branch-52.png",
    "branch-53.png",
    "branch-54.png",
    "branch-55.png",
    "branch-56.png",
    "branch-57.png",
    "branch-58.png",
    "branch-59.png",
    "branch-60.png",
    "branch-61.png",
    "branch-62.png",
    "branch-63.png",
    "branch-64.png",
    "branch-65.png",
    "branch-66.png",
  ];
  const renderSection = (children: React.ReactNode, className?: string) => (
    <div className={`section pt-10 sm:py-[4.5rem] ${className}`}>
      <div className="ui-container">{children}</div>
    </div>
  );

  const { handleSlideChange, products } = useHomeProducts("PASS", "passes");

  const renderIntroduction = () => {
    const highlight = [
      {
        icon: "handshake",
        title: t("intro.handshake"),
        description: t("intro.handshake-desc"),
      },
      {
        icon: "refund",
        title: t("intro.refund"),
        description: t("intro.refund-desc"),
      },
      {
        icon: "call-calling",
        title: t("intro.call-calling"),
        description: t("intro.call-calling-desc"),
      },
      {
        icon: "suitcase",
        title: t("intro.suitcase"),
        description: pfTl(t("intro.suitcase-desc")),
      },
    ];
    return (
      <div className="text-center">
        <p className="mb-2 text-base font-medium text-[#5E6D77]">
          {t("Up to 65% off from New York to Niagara and Hawaii.")}
        </p>
        <h2 className="mb-8 text-[18px] font-semibold leading-[1.875rem] sm:mb-10 sm:text-[1.5rem]">
          {pfTl(t("What is the Tamice Big Pass?"))}
        </h2>
        <div className="grid grid-cols-2 gap-2.5 pb-10 sm:flex sm:flex-row sm:justify-center sm:gap-6 sm:pb-0">
          {highlight.map((item, index) => (
            <div className="rounded-[0.9375rem] border border-[#EAEEF3] px-4 py-6 shadow-md sm:shadow-none">
              <img
                className="mx-auto mb-6 size-10"
                src={icAsset(`../../assets/images/pass-demo/${item.icon}.svg`)}
                alt=""
              />
              <h3 className="mb-2 text-sm font-semibold text-[#232323] sm:text-base">
                {item.title}
              </h3>
              <p className="text-xs font-normal text-[#5E6D77] sm:text-sm">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderIntroductDiscount = () => {
    const highlight = [
      {
        title: t("Top of the Rock Observatory"),
        price: "$66.41",
      },
      {
        title: t("Edge Observatory"),
        price: "$60",
      },
      {
        title: t("Statue of Liberty Landmark Cruise"),
        price: "$45",
      },
      {
        title: t("The Ride"),
        price: "$89",
      },
      {
        title: t("TopView 24-Hour Double-Decker Bus"),
        price: "$108",
      },
      {
        title: t("Central Park Bicycle"),
        price: "$57.44",
      },
      {
        title: t("MLB New York Yankees"),
        price: "$89",
      },
    ];
    return (
      <div className="text-center">
        <h2 className="mx-auto mb-2 w-[90%] text-[18px] font-semibold leading-[1.875rem] sm:mx-0 sm:w-full sm:text-[1.5rem]">
          {t("The more you include the bigger the discount")}
        </h2>
        <p className="mb-6 sm:mb-10">
          {t("Check discounts in real-time and make your purchase")}
        </p>
        <div className="mb-8 flex flex-col rounded-[1.5rem] bg-white px-4 py-4 sm:py-8 md:grid md:grid-cols-7">
          {highlight.map((item, index) => {
            const isLast = index === highlight.length - 1;
            const isFirst = index === 0;
            const borderClass = isTablet
              ? !isFirst
                ? " border-l border-dashed border-[#DCDCDC]"
                : ""
              : !isLast
                ? " border-b border-dashed border-[#DCDCDC] pb-6"
                : "";

            return (
              <div
                key={item.title}
                className={`flex flex-col pb-0 pt-6 md:pb-0 md:pt-0${borderClass}`}
              >
                <p className="mb-4 px-1 text-sm text-[#5E6D77]">{item.title}</p>
                <h3 className="mt-auto text-[18px] font-semibold leading-[1.5rem] text-[#232323] sm:text-[1.25rem]">
                  {item.price}
                </h3>
              </div>
            );
          })}
        </div>
        <p className="mb-4 text-sm font-medium leading-[1.875rem] text-[#5E6D77] sm:text-[1.25rem]">
          {t("On-site purchase")} $514.85
        </p>
        <p className="mb-4 text-base font-normal leading-[1.5rem] text-[#5E6D77] sm:text-[1.25rem]">
          {t("With Big Pass", {
            num: "$257",
          })}
          <br />
          <span className="font-normal text-[#5E6D77]">
            ({t("Big 7")} $211 + {t("Premium")} $46)
          </span>
        </p>
        <div className="flex items-center justify-center gap-3 pb-10 sm:pb-0">
          <p className="text-base font-medium leading-[2.25rem] text-[#5E6D77] sm:text-[1.5rem]">
            {t("pass-intro-Total Payment")}
          </p>
          <p className="text-[18px] font-semibold leading-[1.875rem] text-[#232323] sm:text-[1.5rem]">
            $257
          </p>
          <span className="h-10 content-center rounded-[0.75rem] bg-[#DBE7FF] px-3 text-[18px] font-medium text-primary-light sm:text-base">
            {t("pass-intro-SAVE")}
          </span>
        </div>
      </div>
    );
  };

  const renderProduct = () => {
    return (
      <div>
        <div className="flex flex-col items-center justify-center">
          <UiTitle
            text={t("Travel with Big Pass")}
            className="mx-auto mb-6 sm:mb-10"
          />
        </div>
        {renderSwiper()}
      </div>
    );
  };

  const renderHowToUse = () => {
    // TODO:
    const instructions = [
      {
        title: t("intro.how-to-use-1"),
        description: t("intro.how-to-desc-1"),
      },
      {
        title: t("intro.how-to-use-2"),
        description: t("intro.how-to-desc-2"),
      },
      {
        title: t("intro.how-to-use-3"),
        description: t("intro.how-to-desc-3"),
      },
    ];
    return (
      <div>
        <div className="flex justify-center">
          <UiTitle
            text={t("How to purchase/use the Big Apple Pass")}
            className="mb-8 lg:mb-10"
          />
        </div>
        <div className="flex flex-col gap-8 lg:flex-row lg:gap-[3.75rem] lg:px-[4rem] xl:px-[9.125rem]">
          <CdnImage
            className="h-[304px] w-full lg:size-[22.5rem]"
            src={cdnImg("../../assets/images/pass-demo/banner2.png")}
            alt=""
            cdnParams={{
              width: 500,
              height: 500,
              fit: "cover",
              format: "webp",
            }}
          />
          <div className="mb-10 content-center lg:mb-0">
            {instructions.map((instruction, index) => (
              <div
                key={instruction.title}
                className="group relative flex w-full items-center gap-4"
              >
                <div
                  className={`absolute left-[0.9375rem] z-0 h-full w-[0.125rem] -translate-x-1/2 bg-[#DCDCDC] group-first:top-1/2 group-first:h-1/2 group-last:bottom-1/2 group-last:h-1/2`}
                />
                <span className="z-[1] h-[1.875rem] min-w-[1.875rem] content-center rounded-full bg-primary text-center text-[1.125rem] font-normal leading-[1.6875rem] text-white">
                  {index + 1}
                </span>
                <div className="mb-6 w-full rounded-xl bg-white p-4 group-last:mb-0">
                  <h3 className="mb-1 text-base font-semibold text-[#232323]">
                    {instruction.title}
                  </h3>
                  <p className="w-full whitespace-pre-line text-sm font-normal text-[#5E6D77]">
                    {instruction.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const renderPassCard = (img: string, name: string, location: string) => {
    return (
      <div className="relative size-[15rem] overflow-hidden rounded-[0.75rem]">
        <CdnImage
          src={img}
          alt={name}
          className="size-[15rem] object-cover"
          cdnParams={{
            width: 400,
            height: 400,
            fit: "cover",
          }}
          fetchPriority="low"
          loading="lazy"
        />
        <div
          className="absolute top-0 h-full w-full px-5 py-6 text-white"
          style={{
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100.04%)",
          }}
        >
          <p className="mb-[0.0625rem] text-[18px] font-semibold lg:text-base">
            {t(name)}
          </p>
          <p className="text-sm font-normal">{t(location)}</p>
        </div>
      </div>
    );
  };

  const renderSwiper = () => {
    return (
      <div className="flex w-full flex-col justify-center">
        <div className="w-full">
          <div className="relative">
            <SwiperWithArrow
              onSlideChange={handleSlideChange}
              spaceBetween={Utils.remToPx(1.5)}
              className="musical-swiper"
            >
              {products.map((bean, index) => (
                <SwiperSlide className="!w-[15rem]" key={index}>
                  <a className="size-[15rem]" href={`/pass/${bean.slug}`}>
                    {renderPassCard(bean.thumbnail, bean.name, bean.cityName)}
                  </a>
                </SwiperSlide>
              ))}
            </SwiperWithArrow>
          </div>
        </div>
      </div>
    );
  };
  const renderReview = () => {
    const reviews = [
      {
        name: "S**L",
        avatar: cdnImg(
          "../../assets/images/pass-demo/pexels-chris-moy-226041502-12010417.jpg",
        ),
        review: pfTl(t("intro.review-1")),
      },
      {
        name: "김*원",
        avatar: cdnImg(
          "../../assets/images/pass-demo/view-famous-statue-liberty-new-york.jpg",
        ),
        review: pfTl(t("intro.review-2")),
      },
      {
        name: "깽*터",
        avatar: cdnImg(
          "../../assets/images/pass-demo/simi-iluyomade-8IKd4pl7hbk-unsplash.jpg",
        ),
        review: pfTl(t("intro.review-3")),
      },
    ];
    return (
      <div>
        <div className="flex justify-center">
          <UiTitle text={t("Our customer say")} className="mb-6 lg:mb-10" />
        </div>
        <div className="mx-auto flex w-full flex-col justify-center gap-6 lg:flex-row">
          {reviews.map((review, index) => (
            <div
              key={JSON.stringify(review)}
              className="shaddow-custom flex-1 rounded-[0.9375rem] border border-[#EAEEF3] p-6 pt-10 sm:p-6"
            >
              <svg
                className="mb-4"
                width="2rem"
                height="1.7rem"
                viewBox="0 0 57 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.0312 0L27.2531 6.66238C18.3099 14.2851 13.7183 20.4373 13.4782 25.119C20.3807 26.7396 23.8319 30.6409 23.8319 36.8232C23.8319 40.1844 22.6615 42.9753 20.3206 45.1961C18.0398 47.3569 15.3389 48.4373 12.2177 48.4373C8.79652 48.4373 5.9455 47.1168 3.66469 44.4759C1.44389 41.8349 0.333496 38.4737 0.333496 34.3923C0.333496 22.448 7.56608 10.9839 22.0312 0ZM51.0216 0L56.3335 6.66238C47.3303 14.2851 42.7086 20.4373 42.4685 25.119C49.371 26.7396 52.8222 30.6409 52.8222 36.8232C52.8222 40.1844 51.6818 42.9753 49.401 45.1961C47.1202 47.3569 44.4192 48.4373 41.2981 48.4373C37.6968 48.4373 34.8158 47.0868 32.655 44.3859C30.4943 41.6849 29.4139 38.3537 29.4139 34.3923C29.4139 22.8682 36.6165 11.4041 51.0216 0Z"
                  fill={index === 0 ? "#A8C6FF" : "#DCDCDC"}
                />
              </svg>
              <p className="text-sm font-normal leading-[1.5rem] text-[#5E6D77] sm:text-base">
                {review.review}
              </p>
              <div className="mt-4 flex items-center gap-2 sm:gap-4">
                <CdnImage
                  className="size-8 rounded-full sm:h-12 sm:w-12"
                  src={review.avatar}
                  alt=""
                  loading="lazy"
                  fetchPriority="low"
                  cdnParams={{
                    width: 50,
                    height: 50,
                    fit: "cover",
                    format: "webp",
                  }}
                />
                <h3 className="text-sm font-semibold leading-[1.875rem] text-[#232323] sm:text-[1.25rem]">
                  {review.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const toggleContent = ($event: React.MouseEvent<HTMLButtonElement>) => {
    const content =
      $event.currentTarget.parentElement?.parentElement?.querySelector(
        ".content",
      );
    if (content) {
      content.classList.toggle("hidden");
      $event.currentTarget.classList.toggle("bg-primary");
      $event.currentTarget.classList.toggle("text-white");
      $event.currentTarget.innerHTML = $event.currentTarget.classList.contains(
        "bg-primary",
      )
        ? '<div class="border border-white w-[0.5rem] mx-auto"></div>'
        : `<img class='w-[1.3125rem] h-[1.3125rem] mx-auto' src="${icAsset("../../../assets/icons/plus-black.svg")}" alt="" />`;
    }
  };

  const renderFAQs = () => {
    // TODO:
    const faqs = [
      {
        question: pfTl(t("intro.faqs-1")),
        answer: pfTl(t("intro.faqs-1-answer")),
      },
      {
        question: pfTl(t("intro.faqs-2")),
        answer: pfTl(t("intro.faqs-2-answer")),
      },
      {
        question: pfTl(t("intro.faqs-3")),
        answer: pfTl(t("intro.faqs-3-answer")),
      },
      {
        question: pfTl(t("intro.faqs-4")),
        answer: pfTl(t("intro.faqs-4-answer")),
      },
      {
        question: pfTl(t("intro.faqs-5")),
        answer: pfTl(t("intro.faqs-5-answer")),
      },
      {
        question: pfTl(t("intro.faqs-6")),
        answer: pfTl(t("intro.faqs-6-answer")),
      },
      {
        question: pfTl(t("intro.faqs-7")),
        answer: pfTl(t("intro.faqs-7-answer")),
      },
      {
        question: pfTl(t("intro.faqs-8")),
        answer: pfTl(t("intro.faqs-8-answer")),
      },
    ];
    return (
      <div>
        <div className="flex justify-center">
          <UiTitle text="FAQs" className="mb-6 sm:mb-10" />
        </div>
        <div className="grid grid-cols-1 grid-rows-1 gap-5 sm:grid-cols-2">
          <div className="flex flex-col gap-[1.875rem]">
            {faqs
              .filter((faq, index) => index % 2 === 0)
              .map((faq, index) => (
                <FaqCard key={index} {...faq} />
              ))}
          </div>
          <div className="flex flex-col gap-[1.875rem]">
            {faqs
              .filter((faq, index) => index % 2 === 1)
              .map((faq, index) => (
                <FaqCard key={index} {...faq} />
              ))}
          </div>
        </div>
      </div>
    );
  };
  const renderSections = () => {
    const sections = [
      { children: renderIntroduction() },
      { children: renderIntroductDiscount(), className: "bg-[#F7F8FA]" },
      { children: renderProduct() },
      { children: renderHowToUse(), className: "bg-[#F7F8FA]" },
      { children: renderReview(), className: "pb-0" },
      { children: renderFAQs() },
    ];
    return sections.map((section, index) =>
      renderSection(section.children, section.className),
    );
  };

  const renderBranches = () => {
    const duplicateBranches = [...branches, ...branches];
    return (
      <div className="ui-container mb-8 sm:mb-[7.5rem]">
        <div className="w-full">
          <div className="relative">
            <Swiper
              modules={[Autoplay, Pagination, Navigation]}
              slidesPerView={"auto"}
              spaceBetween={isDesktop ? Utils.remToPx(1.5) : Utils.remToPx(0)}
              loopAdditionalSlides={1}
              loop={true}
              className="pass-swiper"
              speed={3000}
              keyboard={{
                enabled: true,
                onlyInViewport: false,
              }}
              mousewheel={{
                invert: true,
              }}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
            >
              {duplicateBranches.map((branch, index) => (
                <SwiperSlide className="" key={index}>
                  <div className="h-10 text-center sm:h-[3.5rem]">
                    <CdnImage
                      className="mx-auto h-full w-auto"
                      src={cdnImg(`../../assets/images/pass-demo/${branch}`)}
                      alt=""
                      loading={index > 5 ? "lazy" : "eager"}
                      fetchPriority={index > 5 ? "low" : "high"}
                      cdnParams={{
                        height: 60,
                        format: "webp",
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="pass-introduction relative">
      <div className="mt-[3.1044rem]">
        <ProductBannerPassIntroduction />
        {renderBranches()}
        <Tabs tabs={tabs} classTabs="ui-container" />
        {renderSections()}
      </div>
      <BotNav active="PASS" />
    </div>
  );
};

export default PassIntroduction;
